import { render, staticRenderFns } from "./editProductnew.vue?vue&type=template&id=7b116120&scoped=true"
import script from "./editProductnew.vue?vue&type=script&lang=js"
export * from "./editProductnew.vue?vue&type=script&lang=js"
import style0 from "./editProductnew.vue?vue&type=style&index=0&id=7b116120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b116120",
  null
  
)

export default component.exports